<!-- Header -->
<div class="modal-header edit-permissions-modal-component">

  <!-- Title -->
  <h6 class="modal-title" i18n="@@components.edit_permissions_modal.title">Edit user permissions</h6>
  <!-- Title end -->

  <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="close()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<!-- Header end -->

<!-- Content -->
<div class="modal-body invite-users-modal-component">
  <p class="mb-3" i18n="@@components.edit_permissions_modal.description">Here you can edit the user permissions for this tenant.</p>

  @if (disableSubmit) {
    <div class="alert alert-warning mt-3" i18n="@@components.edit_permissions_modal.permission_alert">Please choose at least one permission for the user.</div>
  }

  @if (showForm) {
    <form [formGroup]="form" (ngSubmit)="submitForm()" #editPermissionsForm="ngForm" novalidate>
      <div class="row">
        @for (category of formCategoryUserGroups | iterateObject; track category) {
          <div class="col-sm-4">
            <div class="card h-100">
              <div class="card-header">{{ categories[category.key] }}</div>
              <div class="card-body">
                @for (userGroup of formCategoryUserGroups[category.key]; track userGroup) {
                  <div class="form-check mb-2">
                    <input type="checkbox"
                      class="form-check-input"
                      autocomplete="off"
                      [id]="userGroup"
                      [value]="userGroup"
                      [checked]="form.value.userGroups.includes(userGroup) || (userGroup !== 'admin' && userGroup !== 'owner' && (isAdmin || isOwner))"
                      [disabled]="(fullPermission && (userGroup !== 'admin' && userGroup !== 'owner')) || (isUserManagerSelfEditing && (userGroup === 'admin' || userGroup ==='owner' || userGroup === 'pdc_group.user_admin')) || (userGroup === 'owner' && !this.isTenantOwner && !globalAccess) || (userGroup === 'admin' && !(this.isTenantAdmin || this.isTenantOwner || globalAccess))"
                      (change)="onCheckboxChange($event.target)">
                    <label class="form-check-label" [for]="userGroup"><span class="pb-2">{{ userGroups[userGroup] }}</span>
                    @for (permission of formUserGroupPermissions[userGroup]; track permission) {
                      <div class="permission-list">{{ permissions[permission] }}</div>
                    }
                  </label>
                </div>
              }
            </div>
          </div>
        </div>
      }
    </div>
  </form>
}

</div>
<!-- Content end -->

<!-- Footer -->
<div class="modal-footer modal-body invite-users-modal-component">
  <button type="button" class="btn btn-xs btn-success me-1" (click)="editPermissionsForm.ngSubmit.emit()" [disabled]="disableSubmit" i18n="@@common.submit">Submit</button>
  <button type="button" class="btn btn-xs btn-secondary" (click)="close()" i18n="@@common.close">Close</button>
</div>
<!-- Footer end -->
